import React from "react";
import img from "./repairs.png";
import timetable from "./timetable.jpg";
import "./default.scss";

class Repairs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <div className="bg" style={{ background: `#000` }}>
        <div className="center">
          <img className="img-sm" src={img} />
        </div>
        <div className="center text-xl py-2">
          Booking Timetable is getting repaired and updated
          <br />
          <div className="center">
            <img src={timetable} />
          </div>
        </div>
      </div>
    );
  }
}

export default Repairs;
